module.exports = __webpack_public_path__ + "img/left-light.a47acc8c.png";